import React from 'react';

import { LoaderContainer, LoaderImage } from './Loader.styles';

export const Loader = () => (
  <LoaderContainer className="loader-container">
    <LoaderImage className="loader-wrapper" />
  </LoaderContainer>
);
